import { cn, Modal, ModalBody, useOpenable } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../CurrentCollectionStep/BuilderV2/Types';
import ExperienceVideoThumbnail from './ExperienceVideoThumbnail';
import ModalState from './ModalState';

interface Props {
  className?: string;
  title: string;
  thumbnail: string;
  experienceResource: ExperienceResource;
  hideEnrollAction?: boolean;
}

function ExperienceVideoDetails({
  className,
  title,
  thumbnail,
  experienceResource,
  hideEnrollAction,
}: Props) {
  const { isOpen, onOpen, onClose } = useOpenable();

  return (
    <>
      <ExperienceVideoThumbnail
        className={className}
        alt={title}
        src={thumbnail}
        onClick={onOpen}
      />
      <Modal
        className="h-150 rounded"
        open={isOpen}
        classNames={{
          closeButton: 'left-5 md:left-auto right-5',
        }}
        size="5xl"
        onClose={onClose}
        outsidePress={true}
      >
        <ModalBody
          className={cn(
            'w-full px-0 pb-0 pt-14 sm:px-0 sm:pb-0 sm:pt-14',
            'grid grid-cols-[auto_19.875rem]',
          )}
        >
          <ModalState experienceResource={experienceResource} hideEnrollAction={hideEnrollAction} />
        </ModalBody>
      </Modal>
    </>
  );
}

export default observer(ExperienceVideoDetails);
